import React from "react";
import { Button, Col, Icon, Modal, Row } from "antd";

import { observer } from "mobx-react";
import {
  storiesPapa,
  storiesMama
} from "../data/storiesParentToChild";
import { isFatherToChild } from "../utils/";

const imgs = {
  momoro: {
    a: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_A1.jpg"),
    b: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_B1.jpg"),
    c: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_C1.jpg"),
    d: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_D1.jpg"),
    e: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_E1.jpg"),
    f: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_F1.jpg"),
    g: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_G1.jpg"),
    h: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_H1.jpg"),
    i: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_I1.jpg"),
    j: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_J1.jpg"),
    k: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_K1.jpg"),
    l: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_L1.jpg"),
    m: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_M1.jpg"),
    n: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_N1.jpg"),
    o: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_O1.jpg"),
    p: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_P1.jpg"),
    q: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_Q1.jpg"),
    r: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_R1.jpg"),
    s: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_S1.jpg"),
    t: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_T1.jpg"),
    u: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_U1.jpg"),
    v: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_V1.jpg"),
    w: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_W1.jpg"),
    ai2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_A2.jpg"),
    bi2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_B2.jpg"),
    ci2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_C2.jpg"),
    di2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_D2.jpg"),
    ei2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_E2.jpg"),
    fi2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_F2.jpg"),
    gi2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_G2.jpg"),
    hi2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_H2.jpg"),
    ii2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_I2.jpg"),
    ji2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_J2.jpg"),
    ki2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_K2.jpg"),
    li2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_L2.jpg"),
    mi2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_M2.jpg"),
    ni2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_N2.jpg"),
    oi2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_O2.jpg"),
    pi2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_P2.jpg"),
    qi2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_Q2.jpg"),
    ri2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_R2.jpg"),
    si2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_S2.jpg"),
    ti2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_T2.jpg"),
    ui2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_U2.jpg"),
    vi2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_V2.jpg"),
    wi2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_W2.jpg"),
    // 配偶者なし用の素材
    f2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_F1_2.jpg"),
    g2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_G1_2.jpg"),
    f2i2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_F2_2.jpg"),
    g2i2: require("../imgs/stories/momoro/parent_to_child/ptc_momoro_G2_2.jpg"),
  },
  nakagawa: {
    a: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_A1.jpg"),
    b: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_B1.jpg"),
    c: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_C1.jpg"),
    d: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_D1.jpg"),
    e: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_E1.jpg"),
    f: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_F1.jpg"),
    g: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_G1.jpg"),
    h: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_H1.jpg"),
    i: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_I1.jpg"),
    j: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_J1.jpg"),
    k: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_K1.jpg"),
    l: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_L1.jpg"),
    m: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_M1.jpg"),
    n: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_N1.jpg"),
    o: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_O1.jpg"),
    p: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_P1.jpg"),
    q: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_Q1.jpg"),
    r: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_R1.jpg"),
    s: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_S1.jpg"),
    t: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_T1.jpg"),
    u: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_U1.jpg"),
    v: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_V1.jpg"),
    w: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_W1.jpg"),
    ai2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_A2.jpg"),
    bi2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_B2.jpg"),
    ci2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_C2.jpg"),
    di2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_D2.jpg"),
    ei2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_E2.jpg"),
    fi2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_F2.jpg"),
    gi2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_G2.jpg"),
    hi2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_H2.jpg"),
    ii2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_I2.jpg"),
    ji2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_J2.jpg"),
    ki2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_K2.jpg"),
    li2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_L2.jpg"),
    mi2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_M2.jpg"),
    ni2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_N2.jpg"),
    oi2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_O2.jpg"),
    pi2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_P2.jpg"),
    qi2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_Q2.jpg"),
    ri2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_R2.jpg"),
    si2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_S2.jpg"),
    ti2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_T2.jpg"),
    ui2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_U2.jpg"),
    vi2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_V2.jpg"),
    wi2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_W2.jpg"),
    // 配偶者なし用の素材
    h2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_H1_2.jpg"),
    h2i2: require("../imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_H2_2.jpg"),
  }
};

// タイトル設定
const storyTitles = {
  momoro: {
    a: "親への感謝",
    b: "親孝行の意味",
    c: "配偶者の新たな一面",
    d: "そして家族になる",
    e: "家族ぐるみの時間",
    f: "ムードメーカー",
    g: "家庭円満の立役者",
    h: "見落としていたモノ",
    i: "灯台下暗し",
    j: "うつし鏡",
    k: "戦友との出会い",
    l: "想像するチカラ",
    m: "キュン死体験",
    n: "元気の充電",
    o: "究極の癒し",
    p: "挑戦するチカラ",
    q: "有限の時間",
    r: "幸せの意味",
    s: "成長に必要なもの",
    t: "責任との対峙",
    u: "未来への責任",
    v: "やさしさのブーメラン",
    w: "健康のありがたさ",
  },
  nakagawa: {
    a: "親への感謝",
    b: "親孝行の意味",
    c: "配偶者の新たな一面",
    d: "ママの偉大さ",
    e: "そして家族になる",
    f: "家族ぐるみの時間",
    g: "ムードメーカー",
    h: "家庭円満の立役者",
    i: "見落としていたモノ",
    j: "うつし鏡",
    k: "想像するチカラ",
    l: "キュン死体験",
    m: "元気の充電",
    n: "変わらない夢",
    o: "究極の癒し",
    p: "涙の理由",
    q: "挑戦するチカラ",
    r: "一番大切な時間",
    s: "幸せの意味",
    t: "成長に必要なもの",
    u: "未来への責任",
    v: "誇れる仕事",
    w: "健康のありがたさ",
  }
};

const adapt = (story, book) => {
  const { artistName, parentToChild } = book;
  const grandParentState = parentToChild.grandParentState;
  const isSingle = parentToChild.isSingle === "1";

  // TODO: 判定は作者に依存している。増えたときに考慮必要かも
  if (artistName === "nakagawa") {
    story = story.replace(/パパ/g, parentToChild.creatorNickName);
    story = story.replace(/ママ/g, !isSingle ? parentToChild.spouseNickName : "ママ");
  } else {
    story = story.replace(/ママ/g, parentToChild.creatorNickName);
    story = story.replace(/パパ/g, !isSingle ? parentToChild.spouseNickName : "パパ");
  }
  story = story.replace(/ハナ/g, parentToChild.receiverName);
  story = story.replace(/reg_parentnum/g, isSingle ? '1' : '2');
  story = story.replace(/reg_papatomama/g, isSingle ? parentToChild.creatorNickName : `${parentToChild.creatorNickName}と${parentToChild.spouseNickName}`);

  if (grandParentState === "0") {
    // 両親ともに健在
    story = story.replace(/じいじとばあば/g, `${parentToChild.grandFatherNickName}と${parentToChild.grandMotherNickName}`);
  } else if (grandParentState === "1") {
    // 父のみ健在
    story = story.replace(/じいじとばあば/g, `${parentToChild.grandFatherNickName}`);
  } else if (grandParentState === "2") {
    // 母のみ健在
    story = story.replace(/じいじとばあば/g, `${parentToChild.grandMotherNickName}`);
  }

  return story;
};

const getImg = (book, id, is2Page = false) => {
  const artistName = book.artistName !== "" ? book.artistName : "momoro";
  const isSingle = book.parentToChild.isSingle === "1";

  // 配偶者なし用の素材設定
  if (isSingle) {
    // TODO: 判定は作者に依存している。増えたときに考慮必要かも
    if (artistName === "nakagawa") {
      id = id === 'h' ? `${id}2` : id;
    } else {
      id = id === 'f' || id === 'g' ? `${id}2` : id;
    }
  }

  return imgs[artistName][is2Page ? `${id}i2` : id];
}

const Story = ({ artistName, book, id, stories }) => (
  <div className="story">
    <div
      style={{
        background: "white",
        display: "inline-block",
        marginBottom: "5px",
        padding: "5px 12px"
      }}
    >{`ストーリー ${id.toUpperCase()}：${storyTitles[artistName][id]}`}</div>
    <div
      className="f-14 lh-24"
      style={{ background: "white", padding: "15px 12px" }}
      dangerouslySetInnerHTML={{ __html: adapt(stories[id], book) }}
    />
    <br />
    <div style={{ overflowX: "scroll" }}>
      <div style={{ width: "180%" }}>
        <img
          style={{ float: "left" }}
          src={getImg(book, id)}
        />
        <img
          style={{ float: "right" }}
          src={getImg(book, id, true)}
        />
      </div>
    </div>
  </div>
);

class StoryList extends React.Component {
  constructor() {
    super();
    this.state = { visible: false };
  }

  handleCancel = e => {
    this.setState({ visible: false });
  };

  handleNext = () => {
    const l = this.props.list;
    this.setState({ current: l[l.indexOf(this.state.current) + 1] });
  };

  handlePrevious = () => {
    const l = this.props.list;
    this.setState({ current: l[l.indexOf(this.state.current) - 1] });
  };

  handleSelect = e => {
    this.props.onSelect(this.state.current);
    this.setState({ visible: false });
  };

  handleShowModal = () => {
    this.setState({ visible: true });
  };

  componentWillMount() {
    this.setState({ current: this.props.selected || this.props.list[0] });
  }

  componentWillReceiveProps(props) {
    this.setState({ current: props.selected || props.list[0] });
  }

  render() {
    const current = this.state.current,
      { artistName, list, storyNumber } = this.props,
      prev = list.indexOf(current) === 0,
      next = list.indexOf(current) === list.length - 1;
    const stories = isFatherToChild(this.props.book) ? storiesPapa : storiesMama;

    return (
      <div>
        <div className="story-list link" onClick={this.handleShowModal}>
          <Icon
            type={this.props.selected ? "check-circle" : "edit"}
            style={{ float: "left", marginRight: "5px" }}
            theme="outlined"
          />
          {`ストーリー${storyNumber} `}
          <span className="f-12">{"（見開き2ページ分）"}</span>
          <Icon type="right" />
        </div>
        <Modal
          onCancel={this.handleCancel}
          bodyStyle={{ padding: "10px 0px", background: "#F6F4F9" }}
          //style={{ top: 5 }}
          visible={this.state.visible}
          footer={null}
        >
          <Row className="story-list">
            <Col span={1} />
            <Col span={22}>
              <br />
              <br />
              <Story
                artistName={artistName}
                book={this.props.book}
                id={current}
                stories={stories}
              />
              {"※顔画像はサンプルになります"}
              <br />
              <br />
              <Row className="story-list" type="flex" justify="space-around">
                <Col span={4} onClick={prev ? null : this.handlePrevious}>
                  <Icon
                    style={{
                      color: prev ? "lightgrey" : "#674397",
                      fontSize: 25,
                      float: "left",
                      marginTop: "9px"
                    }}
                    type="left"
                  />
                  <span style={{ top: "11px", position: "relative" }}>
                    前へ
                  </span>
                </Col>
                <Col span={16} style={{ width: "170px" }}>
                  <Button
                    disabled={
                      this.props.disabled.indexOf(this.state.current) !== -1
                    }
                    key="submit"
                    type="primary"
                    onClick={this.handleSelect}
                    style={{
                      width: "170px",
                      padding: "10px",
                      height: "auto"
                    }}
                  >
                    {this.props.disabled.indexOf(this.state.current) !== -1
                      ? "選択済み"
                      : "このストーリーを選ぶ"}
                  </Button>
                </Col>
                <Col span={4} onClick={next ? null : this.handleNext}>
                  <span style={{ top: "11px", position: "relative" }}>
                    次へ
                  </span>
                  <Icon
                    style={{
                      color: next ? "lightgrey" : "#674397",
                      fontSize: 25,
                      float: "right",
                      marginTop: "9px"
                    }}
                    type="right"
                  />
                </Col>
              </Row>
              <br />
            </Col>
            <Col span={1} />
          </Row>
        </Modal>
      </div>
    );
  }
}

export default observer(StoryList);



// WEBPACK FOOTER //
// ./src/components/StorylistParentToChild.js